import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from '@/firebase'
import moment from 'moment'
import './css/style.scss'
import './assets/steve-bw.png'
import './assets/svg/symbols.svg'

Vue.config.productionTip = false
Vue.prototype.$firebase = firebase;
Vue.prototype.$moment = moment;
Vue.prototype.$version = '1.0.0';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
